module.exports = __webpack_public_path__ + "media/details/onsite@3x-f2745377.png";